<template>
  <div>
    <v-snackbar
      class="no-display"
      v-model="snackbar"
      :top="true"
      :color="color"
      :timeout="6000"
    >
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-card class="box no-display">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Student Health Card...</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>
    <!-- <div class="text-center" v-if="false">
      <v-btn
        v-if="getprint"
        class="ma-2 no-display"
        tile
        outlined
        color="warning"
        @click="getPrint()"
      >
        <v-icon left>mdi-printer</v-icon>GetPrint
        <v-icon right></v-icon>
      </v-btn>
    </div> -->
    <v-card class="box1" flat>
      <div>
          <span style="float: right">Record No.: {{ child_data.record_no }}</span>
          <br />
      </div>
      <v-row justify="center">
        <v-col cols="12" sm="2" md="2" align="right">
          <br />
          <img :src="org_basic_data.school_logo" width="60%" alt="logo" />
          <!-- <img
            src="https://eduplusschool.s3.ap-south-1.amazonaws.com/sbpps_logos/logo_1.jpeg"
            width="60%"
            alt="logo"
          /> -->
        </v-col>
        <v-col cols="12" sm="8" md="8">
          <center>
            <br />
            <strong>
              <span v-if="org_basic_data.trust_name">{{
                org_basic_data.trust_name
              }}</span></strong
            >

            <br />
            <strong
              ><span style="font-size: 27px;" v-if="org_basic_data.trust_name">{{
                org_basic_data.school_name
              }}</span></strong
            >

            <br />
            <span v-if="org_basic_data.address">{{
              org_basic_data.address
            }}</span>

            <br />
            <span
              >CBSE Affliation Number: 1130 534 | NABET Accreditation Number: WS
              1923 071</span
            >
            <br />
            <!-- <span>British Council IDS Certification Period: 2020-23</span><br /> -->
            <h3>MEDICAL / HEALTH CARD FOR STUDENTS</h3>
            <span
              ><b> (A.Y. {{ child_data.ay }} )</b>
            </span>
          </center>
        </v-col>
        <v-col cols="12" sm="2" md="2" align="left">
          <img :src="org_basic_data.trust_logo" width="75%" alt="logo" />
          <!-- <img
            src="https://eduplusschool.s3.ap-south-1.amazonaws.com/sbpps_logos/logo_2.jpeg"
            width="75%"
            alt="logo"
          /> -->
        </v-col>
      </v-row>

      <!-- child  info -->
      <div class="box1">
        <v-row dense>
          <!-- First row: Name | Grade & Div | PRN -->
          <v-col cols="12" md="12">
            <v-row dense align="baseline">
              <v-col cols="12" sm="4" md="4">
                <div class="field-row">
                  <span>Name:</span>
                  <span class="underline">{{ child_data.child_name || '' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <div class="field-row">
                  <span>Grade and Div:</span>
                  <span class="underline">{{ child_data.grade || '' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <div class="field-row">
                  <span>PRN:</span>
                  <span class="underline">{{ child_data.prn || '' }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>

          <!-- DOB | Blood Group | Height | Weight | Gender (if you have it) -->
          <v-col cols="12" md="12">
            <v-row dense align="baseline">
              <v-col cols="6" sm="4" md="3">
                <div class="field-row">
                  <span>Date of Birth:</span>
                  <span class="underline">{{ child_data.dob || '' }}</span>
                </div>
              </v-col>
              <v-col cols="6" sm="4" md="3">
                <div class="field-row">
                  <span>Blood Group:</span>
                  <span class="underline">{{ bld_grp || '' }}</span>
                </div>
              </v-col>
              <v-col cols="6" sm="4" md="2">
                <div class="field-row">
                  <span>Height (cms):</span>
                  <span class="underline">{{ child_data.height || '--' }}</span>
                </div>
              </v-col>
              <v-col cols="6" sm="4" md="2">
                <div class="field-row">
                  <span>Weight (kgs):</span>
                 <span class="underline">{{ child_data.weight || '--' }}</span>
                </div>
              </v-col>
              <v-col cols="6" sm="4" md="2">
                <div class="field-row">
                  <span>Gender:</span>
                  <span class="underline">{{ child_data.gender || '--' }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>

          <!-- Father | Mother -->
          <v-col cols="12">
            <v-row dense align="baseline">
              <v-col cols="12" sm="6">
                <div class="field-row">
                  <span>Father’s Name:</span>
                  <span class="underline">{{ child_data.father_name || '' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="field-row">
                  <span>Mother’s Name:</span>
                  <span class="underline">{{ child_data.mother_name || '' }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>

          <!-- Aadhaar | Address -->
          <v-col cols="12">
            <v-row dense align="baseline">
              <v-col cols="12" sm="6">
                <div class="field-row">
                  <span>Aadhaar Card No.:</span>
                  <span class="underline">{{ child_data.aadhar_no || '' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="field-row">
                  <span>Residential Address:</span>
                  <span class="underline">{{ child_data.residential_address || '' }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>

          <!-- Contact | Emergency | Email -->
          <v-col cols="12">
            <v-row dense align="baseline">
              <v-col cols="12" sm="4">
                <div class="field-row">
                  <span>Contact No.:</span>
                  <span class="underline">{{ child_data.father_contact_no || '' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <div class="field-row">
                  <span>Emergency Contact No.:</span>
                  <span class="underline">{{ emrg_contact || '' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <div class="field-row">
                  <span>Email ID:</span>
                  <span class="underline">{{ child_data.email_id || '' }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>

          <!-- Family Doctor Name | Contact -->
          <v-col cols="12">
            <v-row dense align="baseline">
              <v-col cols="12" sm="6">
                <div class="field-row">
                  <span>Family Doctor’s Name:</span>
                  <span class="underline">{{ family_doctor_name || '' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="field-row">
                  <span>Family Doctor’s Contact No.:</span>
                  <span class="underline">{{ family_doctor_contact || '' }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>

          <!-- Avoided Activity | Allergic To -->
          <v-col cols="12">
            <v-row dense align="baseline">
              <v-col cols="12" sm="6">
                <div class="field-row">
                  <span>Any Physical Activity/Sport that Needs to be Avoided:</span>
                  <span class="underline">{{ child_data.physical_activity || '' }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="field-row">
                  <span>Allergic to:</span>
                  <span class="underline">{{ allergy || '' }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>

          <!-- Major Surgery / Medical Emergency -->
          <v-col cols="12">
            <div class="field-row full-width">
              <span>Any Major Surgery/ Medical emergency: Yes/ No </span>
            </div>
          </v-col>
          <v-col cols="12">
  <div class="field-row specify-row">
    <span>If Yes, Please Specify:</span>
    <span class="underline specify-underline">
      {{ child_data.major_surgery || '' }}
    </span>
  </div>
</v-col>

        </v-row>
      </div>
      <!-- child health data  table data-->
      <div class="box2 pagebreak">
        <v-row dense>
            <v-col cols="12" sm="12" md="12">
            <div style="font-size: 18px; margin-bottom: 10px; text-align: center;">
              <b>
              <u>In-School Student Health Observation and Care Log</u>
              </b>
            </div>
            </v-col>
        </v-row>
        <v-simple-table dense class="elevation-1">
          <thead>
            <tr>
              <td style="font-size: 15px; padding: 4px;">Sr. No</td>
              <td style="font-size: 15px; padding: 4px;">Date of Visit</td>
              <td style="font-size: 15px; padding: 4px;">Health Concern</td>
              <td style="font-size: 15px; padding: 4px;">Observation and First Aid/ Care Given</td>
              <td style="font-size: 15px; padding: 4px;">Name of the Attending Person/Medical Professional</td>
              <td style="font-size: 15px; padding: 4px;">Remarks</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, index) in hprob_list" :key="index">
              <td style="font-size: 15px; padding: 4px;">{{ index + 1 }}</td>
              <td style="font-size: 15px; padding: 4px;">{{ i.hprob_date }}</td>
              <td style="font-size: 15px; padding: 4px;">{{ i.nature_hprob }}</td>
              <td style="font-size: 15px; padding: 4px;">{{ i.medication_administered }}</td>
              <td style="font-size: 15px; padding: 4px;">{{ i.name_of_medical_professional }}</td>
              <td style="font-size: 15px; padding: 4px;">{{ i.remark }}</td>
            </tr>
          </tbody>
        </v-simple-table>
        <br><br>
        <v-row dense>
          <v-col cols="12" sm="5" md="5">
            <v-row dense align="center">
              <v-col cols="5" sm="4" md="4" class="text-right">
                <b>Prepared By:</b>
              </v-col>
              <v-col cols="7" sm="8" md="8">
                <hr class="sign-underline" />
              </v-col>
            </v-row>
          </v-col>
          <!-- <v-col cols="12" sm="3" md="2">
            <v-row dense>
              <v-col cols="12" sm="5" md="5"><b> Date:</b></v-col>
              <v-col cols="12" sm="7" md="7">
                <hr class="sign-underline" />
              </v-col>
            </v-row>
          </v-col> -->
          <v-col cols="12" sm="5" md="5">
            <v-row dense align="center">
              <v-col cols="5" sm="4" md="4" class="text-right">
                <b>Approved By:</b>
              </v-col>
              <v-col cols="7" sm="8" md="8">
                <hr class="sign-underline" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  props: ["child_div_id"],
  data: () => ({
    lid: null,
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    org_basic_data: [],
    child_data: [],
    hprob_list: [],
    isvaccination: "",
    isverified: "",
    // child_div_id: "",
    emrg_name: "",
    emrg_contact: "",
    phy_name: "",
    phy_contact: "",
    hosp_name: "",
    hosp_contact: "",
    bld_grp: "",
    medical_condition: "",
    allergy: "",
    child_div_id1: "",
    family_doctor_contact:"",family_doctor_name:"",medical_problem:""
    // getprint: true,
  }),
  created() {
    if (this.$store.getters.lid == null) {
      this.lid = this.$store.getters.lid;
    }
  },
  mounted() {
    // alert(this.child_div_id);
    // this.onLoad();
    // this.child_div_id = JSON.parse(localStorage.getItem("child_div_id"));
    // alert(localStorage.getItem("child_div_id"))
    this.initData();
  },
  methods: {
    // getPrint() {
    //   let routeData = this.$router.resolve({ name: "student-health-card" });
    //   window.open(routeData.href, "_blank");
    //   this.getprint = false;
    // },
    print() {
      setTimeout(function () {
        window.print();
      }, 100);
    },
    async initData() {
      // alert(JSON.parse(localStorage.getItem("child_div_id")));
      // this.snackbar = true;
      this.showdata = false;
      const formdata = {
        // child_div_id: this.child_div_id1,
        child_div_id: JSON.parse(localStorage.getItem("child_div_id")),

        // child_div_id: 5579, // delete this
      };
      console.log("initdata", formdata);
      try {
        const res = await axios.post(
          "/healthCard/getChildHealthInfo",
          formdata
        );
        console.log("result", res);
        if (res.data.flag == "YES") {
          this.child_data = res.data.child_data;
          this.org_basic_data = res.data.org_basic_data;
          this.allergy = res.data.allergy;
          this.medical_condition = res.data.medical_condition;
          this.isvaccination = res.data.isvaccination;
          this.isverified = res.data.isverified;
          this.emrg_name = res.data.emrg_name;
          this.emrg_contact = res.data.emrg_contact;
          this.phy_name = res.data.phy_name;
          this.phy_contact = res.data.phy_contact;
          this.hosp_name = res.data.hosp_name;
          this.hosp_contact = res.data.hosp_contact;
          this.family_doctor_contact = res.data.family_doctor_contact;
          this.family_doctor_name = res.data.family_doctor_name;
          this.medical_problem = res.data.medical_problem;
          this.bld_grp = res.data.bld_grp;
          this.showdata = true;
          // this.bld_grp_list = res.data.bld_grp_list;
          this.hprob_list = res.data.hprob_list;
        } else {
          this.showSnackbar("error", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
          this.msg = "Cant fetch data!!!";
        }
        // this.other_info = false;
        //this.res = res
      } catch (err) {
        this.onerror(err);
        this.msg = "Cant fetch data!!!";
      } finally {
      }
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>
<style scoped>
.box1 {
  background-color: white !important;
  margin: 8px !important;
  padding: 8px;
  border: 1px solid black;
}
.box2 {
  background-color: white !important;
  margin: 8px !important;
  padding: 8px;
}

thead,
tr,
td {
  font-weight: bold !important;
  border: 1px solid black;
  font-size: large;
  text-align: center;
}

/* ────────────────────────────────────────────────
   New underline-style fields layout
──────────────────────────────────────────────── */
.field-row {
  display: flex;
  align-items: baseline;
  margin-bottom: 12px;
  width: 100%;
  gap: 8px; 
}

.field-row span:first-child {
  white-space: nowrap;
  min-width: 50px;         
  padding-right: 15px;
  font-size: 14px;
}

.field-row span.underline {
  flex: 1;
  border-bottom: 1px solid #000;
  min-height: 20px;
  display: inline-block;
  padding: 0 4px;
  font-size: 14px;
  line-height: 1.4;
  margin-right: 50px;
}

.field-row.full-width {
  display: block;
}

.field-row.full-width span:first-child {
  min-width: 340px;           /* wider for long labels like "Any Major Surgery..." */
  display: inline-block;
}

.field-row.full-width span.underline {
  display: block;
  margin-top: 2px;
}

/* Print adjustments */
@media print {
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  .v-snackbar,
  .v-overlay {
    display: none !important;
  }

  header, footer, nav, date {
    display: none !important;
  }

  .box1, .box2 {
    margin: 0;
    padding: 4px;
    border: 1px solid black;
  }

  .field-row {
    margin-bottom: 10px;
  }
.specify-row {
  display: flex;
  align-items: center;
  width: 100%;
}

.specify-row span:first-child {
  white-space: nowrap;
  margin-right: 8px;
  font-size: 14px;
}

.specify-underline {
  flex: 1;
  border-bottom: 1px solid #000;
  min-height: 20px;
  padding-left: 6px;
}

  .field-row span.underline {
    border-bottom: 1px solid #000 !important;
  }

  @page {
    size: 11.69in 8.27in !important;
    margin: 0;
  }

  .pagebreak{
    page-break-before: always !important;
  }

  .sign-underline {
    margin-top: 30px;
    border-bottom: 1px solid #000;
    display: block;
    width: 100%;
  }
}

.sign-underline {
  margin-top: 23px;
  border-bottom: 1px solid #000;
  display: block;
}
</style>
